import { Flex, Progress, Spinner, Text, VStack } from '@chakra-ui/react'
import Card from 'components/Card/Card'

const DashboardLoader = () => {
    return (
        <Flex w="full" h="280px">
            <Card>
                <Flex w="full" h="full" justifyContent="center" alignItems="center">
                    <VStack spacing={2}>
                        <Text size="md" fontWeight="bold">Carregando Dados do Dashboard</Text>
                        <Progress size='xs' colorScheme='green' isIndeterminate w="480px" />
                    </VStack>
                </Flex>
            </Card>
        </Flex>
    )
}

export default DashboardLoader